import apiClient from 'apiClient';
import { CommissionTermsValidationResponse } from './types';

export const assignCommission = (clubId: string, commissionTermId: string): Promise<void> => {
  return apiClient.post(`/api/v1/broker-management/commission-term/${commissionTermId}/assign/club/${clubId}`);
};

export const unassignCommission = (clubId: string, commissionTermId: string): Promise<void> => {
  return apiClient.post(`/api/v1/broker-management/commission-term/${commissionTermId}/unassign/club/${clubId}`);
};

export const checkCommissionTermsCoverage = async (clubId: string): Promise<CommissionTermsValidationResponse> => {
  const response = await apiClient.get(`api/v1/broker-management/commission-term/coverage/club/${clubId}`);
  return response.data;
};
